export enum TheaterType {
  APJ = 'APJ',
  EMEA = 'EMEA',
  NA_LATAM = 'NA_LATAM',
}

export enum TheaterTypeIndex {
  APJ = 1,
  EMEA = 2,
  NA_LATAM = 3,
}

export const TheaterTypeIndexMapper: { [key: number]: TheaterType } = {
  [TheaterTypeIndex.APJ]: TheaterType.APJ,
  [TheaterTypeIndex.EMEA]: TheaterType.EMEA,
  [TheaterTypeIndex.NA_LATAM]: TheaterType.NA_LATAM,
};
